import React from 'react';

const cardStyle = {
    background: '#ffffff',
    borderRadius: '0.625rem',
    boxShadow: '0 .125rem .625rem rgba(90,97,105,.12)',
    border: '1px solid #e1e5eb',
    minHeight: '320px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '2rem',
};

function TableStateCard({ loading = false, icon = 'table_chart', title = '', message = '' }) {
    if (loading) {
        return (
            <div style={cardStyle}>
                <div className="containerLoader" style={{ display: 'block', position: 'static', width: '100%' }}>
                    <div className="loader"></div>
                </div>
            </div>
        );
    }

    return (
        <div style={cardStyle}>
            <div style={{ textAlign: 'center', maxWidth: '420px' }}>
                <div
                    style={{
                        width: '72px',
                        height: '72px',
                        margin: '0 auto 1rem',
                        borderRadius: '50%',
                        background: '#f5f6f8',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <i className="material-icons" style={{ fontSize: '34px', color: '#818ea3' }}>{icon}</i>
                </div>
                <h4 style={{ marginBottom: '0.75rem', color: '#3d5170', fontWeight: 500 }}>
                    {title}
                </h4>
                <p style={{ margin: 0, color: '#818ea3', lineHeight: 1.6 }}>
                    {message}
                </p>
            </div>
        </div>
    );
}

export default TableStateCard;
